import ComponentInstancePage from '@totem/components/customDashboard/home/ComponentInstancePage';
import ComponentPage from '@totem/components/customDashboard/home/ComponentPage';
import Home from '@totem/components/customDashboard/home/Home';
import Portfolio from '@totem/components/portfolio/overview/Portfolio';
import ServiceMatrixPage from '@totem/components/portfolio/serviceMatrix/ServiceMatrixPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import UserHome from '@totem/components/userContext/userHome/userHome';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const portfolioRoutes: Route[] = [
  {
    path: '',
    pageTitle: 'Home',
    component: UserHome, // This is the component that checks user preferences and routes to appropriate home page.
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  // Portfolio
  {
    path: 'portfolio',
    pageTitle: 'Portfolio',
    component: Portfolio,
    exact: true,
    breadcrumbs: [{ label: 'Portfolio', link: '/portfolio' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'portfolio/serviceMatrix',
    pageTitle: 'Service Matrix',
    component: ServiceMatrixPage,
    exact: true,
    breadcrumbs: [
      { label: 'Portfolio', link: '/portfolio' },
      { label: 'Service Matrix' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  // Home
  {
    path: 'home',
    pageTitle: 'Home',
    component: Home,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'component/:id',
    pageTitle: '',
    component: ComponentPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'componentInstance/:page/:pageNumber/:componentInstanceId',
    pageTitle: '',
    component: ComponentInstancePage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
